import {useTranslation} from 'react-i18next';
import {TEticketSubscriptionEvent} from '../../../../redux/eTicket/eTicket.type';
import {getSubscriptionEventState, subscriptionEventStateConfig} from '../memberTicket.utils';
import MemberDateBox from '../memberDateBox/MemberDateBox';
import * as css from './MemberInfoSheet.css';

interface MemberSeriesEventsProps {
    events: TEticketSubscriptionEvent[];
}

/* The events included in the series, read-only — redeeming itself happens in the redeem sheet */
function MemberSeriesEvents({events}: MemberSeriesEventsProps) {
    const {t} = useTranslation('eTicket');

    return (
        <css.events data-cy="member-series-events">
            <css.eventsTitle>
                {t('seriesEvents')}
                <css.eventsSubtitle>{t('seriesEventsSubtitle')}</css.eventsSubtitle>
            </css.eventsTitle>
            {events.map(event => {
                const {textKey, available} = subscriptionEventStateConfig[getSubscriptionEventState(event)];
                return (
                    <css.eventRow key={event.eid} data-cy={`member-series-event-${event.eid}`}>
                        <MemberDateBox ts={event.timeStart} variant="square" />
                        <css.eventText>
                            <css.eventName>{event.title}</css.eventName>
                            {event.location && <css.eventMeta>{event.location}</css.eventMeta>}
                        </css.eventText>
                        {!available && <css.eventBadge>{t(textKey)}</css.eventBadge>}
                    </css.eventRow>
                );
            })}
        </css.events>
    );
}

export default MemberSeriesEvents;
